/* Recently viewed products, kept entirely in the visitor's own browser.
 *
 * Omar, 2026-09-05: dealers compare finishes side by side and lose the trail on every click.
 *
 * ⚠️ WHY localStorage AND NOT THE CUSTOMER RECORD. Two reasons, and the second is the practical
 * one: no browsing history is stored against a dealer anywhere on the server, and the product
 * page stays cacheable. Rendering a per-visitor list in Liquid would make all 6,388 product pages
 * unique to their viewer and defeat Shopify's full-page cache.
 *
 * ⚠️ THE GATE IS NOT BYPASSED. This does not build cards. It asks the STORE for each product's
 * own card markup, which is rendered through card-product.liquid and therefore through bhx-gate,
 * so a viewer who may not see prices gets cards with no price and no add button, exactly as they
 * would anywhere else. Nothing here knows a price, so nothing here can leak one.
 *
 * Fails silent and stays hidden: a dealer with an empty history, a blocked storage API or a failed
 * fetch simply never sees the section, rather than seeing an empty heading.
 */
(function () {
  "use strict";

  var KEY = "bhx:recent";
  var MAX = 12; // Stored. How many are SHOWN comes from the section's data-limit.

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      // Private mode, storage disabled, or corrupted JSON. Treat as no history.
      return [];
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* nothing to do */ }
  }

  function remember(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  function cardUrl(handle) {
    // `view=card` renders the product through the store's own card template. If that view does
    // not exist the request 404s and the entry is skipped, which is the safe direction to fail.
    return "/products/" + encodeURIComponent(handle) + "?section_id=bhx-card";
  }

  function render(section) {
    var current = section.getAttribute("data-current-handle");
    var limit = parseInt(section.getAttribute("data-limit"), 10) || 8;
    var handles = read().filter(function (h) { return h && h !== current; }).slice(0, limit);
    if (!handles.length) return;

    var list = section.querySelector(".bhx-recent__list");
    var parser = new DOMParser();

    Promise.all(handles.map(function (handle) {
      return fetch(cardUrl(handle))
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = parser.parseFromString(html, "text/html");
          // The section wrapper Shopify returns is not wanted, only the card inside it.
          var card = doc.querySelector(".card-wrapper, .card");
          return card ? { handle: handle, node: card } : null;
        })
        .catch(function () { return null; });
    })).then(function (results) {
      var kept = results.filter(Boolean);
      if (!kept.length) return; // Stay hidden rather than show an empty rail.
      kept.forEach(function (item) {
        var li = document.createElement("li");
        li.className = "bhx-recent__item";
        li.appendChild(item.node);
        list.appendChild(li);
      });
      section.hidden = false;
      // Let the card script give these the same hover overlay as everything else.
      document.dispatchEvent(new CustomEvent("bhx:cards-added", { detail: { root: section } }));
    });
  }

  function init() {
    var section = document.querySelector("[data-bhx-recent]");
    var handle = section ? section.getAttribute("data-current-handle") : null;
    // Render BEFORE remembering, so the page you are on is not the first thing in its own list.
    if (section) render(section);
    remember(handle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
